import Vue from 'vue';
import {
  Button,
  message,
  Form,
  Input,
  Drawer,
  Dropdown,
  Card,
  Icon,
  Menu,
  Modal,
  Table,
  Tabs,
  Tag,
  LocaleProvider,
  Checkbox,
  Layout,
  Avatar,
  Breadcrumb,
  Progress,
  Timeline,
  Alert,
  Divider,
  Pagination,
  Select,
  Col,
  AutoComplete,
  Row,
  Tooltip,
  Cascader,
  TimePicker,
  DatePicker,
  InputNumber,
  Spin,
  Radio,
} from 'ant-design-vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
// import qs from 'qs';
import waterfall from 'vue-waterfall2';
import Meta from 'vue-meta';
import VueClipboard from 'vue-clipboard2';
import clipboard from 'clipboard';
import App from './App.vue';
import router from './router';
import store from './store';
import 'ant-design-vue/dist/antd.css';

// Vue.prototype.$qs = qs;
Vue.prototype.clipboard = clipboard;
Vue.use(VueClipboard);
Vue.use(VueAxios, axios);
// ant-design ---start
Vue.prototype.$message = message;
Vue.prototype.$confirm = Modal.confirm;
Vue.use(Button);
Vue.use(Input);
Vue.use(Form);
Vue.use(Icon);
Vue.use(LocaleProvider);
Vue.use(Drawer);
Vue.use(Dropdown);
Vue.use(Card);
Vue.use(Menu);
Vue.use(Modal);
Vue.use(Table);
Vue.use(Tabs);
Vue.use(Tag);
Vue.use(Checkbox);
Vue.use(Layout);
Vue.use(Avatar);
Vue.use(Breadcrumb);
Vue.use(Progress);
Vue.use(Timeline);
Vue.use(Alert);
Vue.use(Divider);
Vue.use(Pagination);
Vue.use(Select);
Vue.use(Col);
Vue.use(AutoComplete);
Vue.use(Row);
Vue.use(Cascader);
Vue.use(InputNumber);
Vue.use(Tooltip);
Vue.use(TimePicker);
Vue.use(DatePicker);
Vue.use(Spin);
// ant-design ---end
Vue.use(waterfall);
Vue.use(Meta);
Vue.use(Radio);
Vue.config.productionTip = false;
// eslint-disable-next-line func-names
Vue.prototype.isMobile = function () {
  return /Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent);
};

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
